import sideBarDefaultLogo from "@assets/images/logo.png";
import { useCloud } from "@dashboard/auth/hooks/useCloud";
import { useLegacyThemeHandler } from "@dashboard/components/Sidebar/user/Controls";
import { Ripple } from "@dashboard/ripples/components/Ripple";
import { Avatar, Box, Text, Tooltip } from "@saleor/macaw-ui-next";
import { CloudIcon } from "lucide-react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { useEnvLink } from "./menu/hooks/useEnvLink";
import { rippleCloudEnvLink } from "./ripples/cloudEnvLink";

export const MountingPoint = () => {
  const { theme } = useLegacyThemeHandler();
  const logo = theme === "defaultLight" ? sideBarDefaultLogo : sideBarDefaultLogo;
  const { isAuthenticatedViaCloud } = useCloud();
  const envLink = useEnvLink();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      display="flex"
      gap={3}
      paddingX={4}
      paddingY={5}
      alignItems="center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* <Avatar.Store src={logo} scheme="accent1" size="large" /> */}

      <Avatar.Store
        src={logo}
        size="large"
        __width="140px"
        __height="40px"
        __backgroundColor="transparent"
        style={{
          objectFit: "contain", // Ensures the logo fits within the dimensions without distortion
        }}
      />
      {/* <Text size={3} fontWeight="bold" __flex="1">
        PDC Market Dashboard
      </Text> */}
      {isAuthenticatedViaCloud && (
        <>
          <Ripple model={rippleCloudEnvLink} />
          <Tooltip>
            <Tooltip.Trigger>
              <Box
                as="a"
                href={envLink}
                target="_blank"
                rel="noopener noreferrer"
                display="flex"
                alignItems="center"
                color="default2"
                paddingRight={1}
                style={{
                  opacity: isHovered ? 1 : 0,
                  transition: "opacity 0.15s ease-in-out",
                }}
                data-test-id="cloud-environment-link"
              >
                <CloudIcon size={16} />
              </Box>
            </Tooltip.Trigger>
            <Tooltip.Content side="bottom">
              <Tooltip.Arrow />
              <Text size={2}>
                <FormattedMessage defaultMessage="Go to Saleor Cloud" id="EXqb2l" />
              </Text>
            </Tooltip.Content>
          </Tooltip>
        </>
      )}
    </Box>
  );
};
